import React from 'react'
import { Link } from 'react-router-dom'
import Title from 'src/components/Title'
const Page404 = () => {
  return (
    <>
      <Title bannerTitle={'Page Not Found'} />
      <section className="inner-wrapper">
        <div className="container content">
          <div className="row pt-5">
            <div className="d-flex justify-content-center">
              <div className="px-3">
                <h1 className="float-start display-3 me-4">404</h1>
                <h4 className="pt-3">Oops! You{"'"}re lost.</h4>
                <p className="text-medium-emphasis float-start">
                  The page you are looking for was not found.
                </p>
                <Link to="/">
                  <br />
                  Go Back to Home Page
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Page404
